import { Link } from 'react-router-dom';
import { mockCategories } from '@/mocks/videos';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            海量内容 · 应有尽有
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            蘑菇视频官网为您精心整理了五大内容板块，无论您喜欢什么类型的视频，都能在这里找到心头好
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-5">
          {mockCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-2xl bg-background-100 hover:bg-accent-50 transition-all duration-300 p-6 md:p-7 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl md:text-3xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}